export enum eCDV3ItemTypes {
  percentage_of_loan_amount = 'percentage_of_loan_amount',
  origination_fee_other = 'origination_fee_other',
  title_fee = 'title_fee',
  title_fee_other = 'title_fee_other',
  other_loan_cost = 'other_loan_cost',
  endorsement = 'endorsement',
  endorsement_other = 'endorsement_other',
  recording_fee = 'recording_fee',
  recording_fee_other = 'recording_fee_other',
  tax = 'tax',
  tax_other = 'tax_other',
  interest_prepayment = 'interest_prepayment',
  non_interest_prepayment = 'non_interest_prepayment',
  prepayment_other = 'prepayment_other',
  escrow_at_closing = 'escrow_at_closing',
  escrow_at_closing_other = 'escrow_at_closing_other',
  aggregate_adjustment = 'aggregate_adjustment',
  other_fee = 'other_fee',
  lender_credit = 'lender_credit',
  payoff = 'payoff',
  property_taxes = 'property_taxes',
  hoa_fee = 'hoa_fee',
  sale_price_of_property = 'sale_price_of_property',
  personal_property_sale = 'personal_property_sale',
  buyer_deposit = 'buyer_deposit',
  loan_amount = 'loan_amount',
  existing_loans_assumed = 'existing_loans_assumed',
  seller_credit = 'seller_credit',
  seller_excess_deposit = 'seller_excess_deposit',
  buyer_credit_from_seller = 'buyer_credit_from_seller',
  buyer_credit_from_third_party = 'buyer_credit_from_third_party',
  buyer_reimbursement_to_seller = 'buyer_reimbursement_to_seller',
  buyer_reimbursement_other_to_seller = 'buyer_reimbursement_other_to_seller',
  buyer_reimbursement_from_seller = 'buyer_reimbursement_from_seller',
  buyer_reimbursement_other_from_seller = 'buyer_reimbursement_other_from_seller',
  buyer_reimbursement_to_third_party = 'buyer_reimbursement_to_third_party',
  sales_tax = 'sales_tax',
  appraisal_fee = 'appraisal_fee',
}
